import { TYPOGRAPHY_VARIANTS } from '../typography/typography';
export var getFormHelperTextStyles = function (theme) { return ({
    transform: 'translate(-12px, 0px)',
    color: theme.backrs.colors['Colors/Text/text-tertiary'],
    fontWeight: TYPOGRAPHY_VARIANTS['text-sm-regular'].fontWeight,
    lineHeight: TYPOGRAPHY_VARIANTS['text-sm-regular'].lineHeight,
    fontSize: TYPOGRAPHY_VARIANTS['text-sm-regular'].fontSize,
    '&.Mui-disabled': {
        color: "".concat(theme.backrs.colors['Colors/Text/text-tertiary'], " !important"),
    },
    '&.Mui-disabled.Mui-error': {
        color: "".concat(theme.backrs.colors['Colors/Text/text-error-primary'], " !important"),
    },
}); };
export var getFormLabelStyles = function (theme) { return ({
    transform: 'translate(0px, -24px) !important',
    color: theme.backrs.colors['Colors/Text/text-primary'],
    fontWeight: TYPOGRAPHY_VARIANTS['text-md-medium'].fontWeight,
    fontSize: TYPOGRAPHY_VARIANTS['text-sm-medium'].fontSize,
    '&.Mui-focused': {
        color: theme.backrs.colors['Colors/Text/text-primary'],
    },
    '&.Mui-error': {
        color: theme.backrs.colors['Colors/Text/text-error-primary'],
        '&.Mui-focused': {
            color: theme.backrs.colors['Colors/Text/text-error-primary'],
        },
    },
    '&.Mui-disabled': {
        color: "".concat(theme.backrs.colors['Colors/Text/text-primary'], " !important"),
    },
    '&.Mui-disabled.Mui-error': {
        color: "".concat(theme.backrs.colors['Colors/Text/text-error-primary'], " !important"),
    },
}); };
export var getFormLabelAsteriskStyles = function (theme) { return ({
    fontWeight: TYPOGRAPHY_VARIANTS['text-md-medium'].fontWeight,
    fontSize: TYPOGRAPHY_VARIANTS['text-sm-medium'].fontSize,
    color: theme.backrs.colors['Colors/Text/text-brand-tertiary'],
    '&.Mui-error': {
        color: theme.backrs.colors['Colors/Text/text-brand-tertiary'],
        '&.Mui-focused': {
            color: theme.backrs.colors['Colors/Text/text-brand-tertiary'],
        },
    },
}); };
export var getOutlinedInputRootStyles = function (theme) { return ({
    display: 'flex',
    width: 'auto',
    minHeight: theme.backrs.spacing['spacing-6xl'],
    paddingTop: theme.backrs.spacing['spacing-md'],
    paddingBottom: theme.backrs.spacing['spacing-md'],
    paddingLeft: theme.backrs.spacing['spacing-lg'],
    paddingRight: theme.backrs.spacing['spacing-lg'],
    borderRadius: theme.backrs.radius['radius-md'],
    border: "1px solid ".concat(theme.backrs.colors['Colors/Border/border-primary']),
    gap: theme.backrs.spacing['spacing-md'],
    transition: 'box-shadow 0.2s ease-in-out, border-color 0.2s ease-in-out',
    backgroundColor: theme.backrs.colors['Colors/Base/White'],
    '&:not(.MuiInputBase-multiline)': {
        height: '40px',
        minHeight: 'unset',
    },
    '&.Mui-focused': {
        borderColor: theme.backrs.colors['Colors/Border/border-brand'],
        boxShadow: "0 0 0 1px ".concat(theme.backrs.colors['Colors/Border/border-brand']),
    },
    '&.Mui-disabled': {
        backgroundColor: theme.backrs.colors['Colors/Background/bg-disabled-subtle'],
        borderColor: theme.backrs.colors['Colors/Border/border-disabled'],
        boxShadow: theme.backrs.shadows['shadow-xs'],
    },
    '&.Mui-error': {
        borderColor: theme.backrs.colors['Colors/Border/border-error-subtle'],
        '&.Mui-focused': {
            boxShadow: "0 0 0 1px ".concat(theme.backrs.colors['Colors/Border/border-error']),
        },
    },
    '& .MuiAutocomplete-endAdornment': {
        top: "".concat(theme.backrs.spacing['spacing-2xl'], " !important"),
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
}); };
export var getOutlinedInputNotchedOutlineStyles = function () { return ({
    border: 'none',
}); };
export var getOutlinedInputInputStyles = function (theme) { return ({
    color: theme.backrs.colors['Colors/Text/text-primary'],
    padding: theme.backrs.spacing['spacing-none'],
    fontWeight: TYPOGRAPHY_VARIANTS['text-md-regular'].fontWeight,
    fontSize: TYPOGRAPHY_VARIANTS['text-md-regular'].fontSize,
    display: 'flex',
    borderRadius: theme.backrs.radius['radius-sm'],
    '&::placeholder': {
        color: theme.backrs.colors['Colors/Text/text-placeholder'],
        opacity: 1,
    },
    '&:-webkit-autofill': {
        transition: 'background-color 600000s 0s, color 600000s 0s',
    },
}); };
